export default __webpack_public_path__ + "static/itineraries-086efbbc6cdbfaa26c0f5e933ae418b3.svg";